/**
 * Global error handler; shows a Buefy snackbar toast on screen
 *
 * @param {Error} err - Error object, will be printed to the console
 * @param {string} message - Message to display for the user
 * @param {boolean} [critical=false] - For fatal errors, force a page refresh when the user clicks the action button
 * @param {object} [extraOptions={}] - Extra Buefy snackbar options to override defaults
 */
export function handleError(err, message, critical = false, extraOptions = {}) {
    console.error('Error:', err, message); // eslint-disable-line no-console
    const snackbarOptions = {
        message,
        type: 'is-danger',
    };

    // for critical errors, the action button reloads the page
    if (critical) {
        snackbarOptions.indefinite = true;
        snackbarOptions.onAction = () => { this.$router.go(); };
        snackbarOptions.actionText = 'Retry';
    }

    this.$buefy.snackbar.open({
        ...snackbarOptions,
        ...extraOptions,
    });
}

// install as a global mixin
export default {
    install(Vue, options = {}) {
        const { afterNotification } = options;

        Vue.mixin({
            methods: {
                $handleError(...args) {
                    // show error notification
                    handleError.apply(this, args);

                    // call optional callback
                    if (afterNotification) {
                        afterNotification.apply(this, args);
                    }
                },
            },
        });
    },
};
